import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import authService from '../services/auth'

interface ProtectedRouteProps {
  children: React.ReactNode
  requireAuth?: boolean
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  requireAuth = true 
}) => {
  const location = useLocation()
  const isAuthenticated = authService.isAuthenticated()

  // If authentication is required and user is not authenticated
  if (requireAuth && !isAuthenticated) {
    // Redirect to login with return URL
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  // If authentication is not required and user is authenticated
  // (e.g., login page when already logged in)
  if (!requireAuth && isAuthenticated) {
    // Redirect to problems page
    return <Navigate to="/problems" replace />
  }

  return <>{children}</>
}

export default ProtectedRoute 